<template>
  <div class="inherited-hint" v-if="hasCustomImage">
    <v-icon size="14" color="primary">mdi-pencil-circle</v-icon>
    <span>This image overrides the default project social share image.</span>
    <button
      type="button"
      class="inherited-hint__action"
      @click="$emit('reset')"
    >
      Reset to default
    </button>
  </div>
  <div
    class="inherited-hint inherited-hint--preview"
    v-else-if="defaultImageUrl"
  >
    <img class="inherited-hint__thumb" :src="defaultImageUrl" alt="" />
    <span
      >Using the default project social share image set in
      <router-link :to="`/projects/${currentUser.active_project.id}/edit`"
        >Site Meta Tags</router-link
      >
      (og:image). Upload an image above to override it for this page.</span
    >
  </div>
  <div class="inherited-hint inherited-hint--warning" v-else>
    <v-icon size="14" color="#c00">mdi-alert-circle-outline</v-icon>
    <span
      >No default project social share image could be found in
      <router-link :to="`/projects/${currentUser.active_project.id}/edit`"
        >Site Meta Tags</router-link
      >
      (no og:image tag). Social shares of this page will have no image unless
      you upload one here.</span
    >
  </div>
</template>

<script>
export default {
  name: "InheritedImageHint",
  props: {
    value: { type: [File, Object], default: null },
    defaultImageUrl: { type: String, default: null },
  },
  computed: {
    hasCustomImage() {
      // CarrierWave attachments serialize as an object even when empty
      // (e.g. `{ url: null, thumb: { url: null } }`), so `!!this.value`
      // alone isn't enough to tell "no image" from "image set". Check the
      // same way Uploader.vue derives its preview `src`.
      const value = this.value;
      if (!value) return false;
      if (value instanceof File) return true;
      return !!(value.url || value.preview?.thumb?.url);
    },
  },
};
</script>

<style scoped lang="scss">
.inherited-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #757575;

  .v-icon {
    margin-top: 1px;
  }

  &__action {
    flex-shrink: 0;
    color: var(--v-primary-base);
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    font-size: inherit;
  }

  &__thumb {
    width: 48px;
    height: 27px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid var(--v-border-base);
    flex-shrink: 0;
  }

  &--warning {
    color: #c00;
  }

  ::v-deep a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
